import {
    addToChainAfter
} from "@insite/client-framework/HandlerCreator";
import { API_URL_CURRENT_FRAGMENT } from "@insite/client-framework/Services/ApiService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Pages/SavedOrderDetails/Handlers/DisplayOrder";


// this will enable HMR for custom handlers
if (module.hot) {
    module.hot.accept();
    const originalChain = chain.slice();
    module.hot.dispose(data => {
        chain.length = 0;
        originalChain.forEach(o => chain.push(o));
    });
}

// trying to reference a handler not in the chain will result in a warning and the chain will not be modified
addToChainAfter(
    chain,
    PopulateApiParameter,
    props => {
        props = {
            ...props,
            parameter: {
                ...props.parameter,
                cartId: props.parameter.cartId ?? API_URL_CURRENT_FRAGMENT
            }
        }
        props.apiParameter = {
            ...props.apiParameter,
            cartId: props.apiParameter?.cartId ?? API_URL_CURRENT_FRAGMENT,
            forceRecalculation: false
        }
        
    },
);
